import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface AuthStore {
  email: string;
  setEmail: (email: string) => void;
  clearEmail: () => void;
}

export const useAuthStore = create<AuthStore>()(
  devtools(
    persist(
      (set) => ({
        email: '',
        setEmail: (email: string) => set({ email }),
        clearEmail: () => set({ email: '' }),
      }),
      {
        name: 'auth-email-storage',
        partialize: (state) => ({ email: state.email }),
      }
    ),
    { name: 'auth-store' }
  )
);
